import { render, staticRenderFns } from "./lkuPangkat.vue?vue&type=template&id=30935460"
import script from "./lkuPangkat.vue?vue&type=script&lang=js"
export * from "./lkuPangkat.vue?vue&type=script&lang=js"
import style0 from "./lkuPangkat.vue?vue&type=style&index=0&id=30935460&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports